export default {
  tr: {
    "cursor": "pointer"
  },
  center: {
    "textAlign": "center",
    "verticalAlign": "middle",
    "align": "center",
    "margin": "0 auto"
  },
  tdNoBorder: {
    "border": "none",
    "borderTop": "none !important",
    "borderRight": "none !important"
  },
  table: {
    "borderCollapse": "collapse",
    "border": "0px !important",
    "borderBottom": "0px !important"
  },
  saveBtnBottom: {
    "paddingBottom": "12px"
  },
  addBtn: {
    "paddingLeft": "12px",
    "textAlign": "center"
  },
  addTitle: {
    "display": "inline-block"
  },
  backBtnRight: {
    "paddingRight": "12px"
  },
  choicesDelBtn: {
    "paddingBottom": "12px"
  }
};


// WEBPACK FOOTER //
// ./src/views/projectconfig/styles.js